export const billingCycles = {
  ANNUALLY: 'annually',
  MONTHLY: 'monthly',
};

export const billingCycleType = {
  YEAR: 'year',
  MONTH: 'month',
};

export const billingCyclePayload = {
  [billingCycles.ANNUALLY]: 'Yearly',
  [billingCycles.MONTHLY]: 'Monthly',
};

export const billingCycleOptions = [
  {
    text: billingCyclePayload[billingCycles.ANNUALLY],
    value: billingCycleType.YEAR,
  },
  {
    text: billingCyclePayload[billingCycles.MONTHLY],
    value: billingCycleType.MONTH,
  },
];

export type BillingCycleTypes =
  typeof billingCycles[keyof typeof billingCycles];
